<template lang="pug">
  .component-policy
    .inner-content
      template(v-if="$is('listing')" )
        .row
          .column.shrink
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              template(v-if="item.status ==='PROCESSING'" )
                .dropdown-buttons
                  ActionButton(:action="stopProcessing") Stop
          .column.shrink
            .field C{{item.id}}

                //span(style="color:red; cursor:pointer").fa.fa-stop
          .column.shrink
            .field Operation:
            .field {{item.operation}}
          .column.small-6
            .field Payload:
            .field {{ JSON.stringify(item.payload)}}
          .column
            .field Status:
            .field {{item.status}}
              template(v-if="item.info" )
                .field
                  small {{item.info.processing}}/{{item.info.total}} ({{Math.round(item.info.processing / item.info.total * 100)}}%)
          .column.shrink
            .field Output:
            .field(v-if="item.output")
              a(v-on:click="openUrl(item.output)") Download
          .column.shrink
            .field-url-detail
              router-link(:to="{name:'cargo-operation', params:{id:item.id}}")
                i.fa.fa-angle-right.fa-3x.action
      template(v-if="$is('detail')" )
          .row
            .column
              .card.p-3
                .row
                  .column.shrink
                    .field Operation:
                    .field {{item.operation}}
                  .column.shrink
                    .field Status:
                    .field {{item.status}}
                    template(v-if="item.info && item.status === 'PROCESSING'" )
                      .field
                        small {{item.info.processing}}/{{item.info.total}} ({{Math.round(item.info.processing / item.info.total * 100)}}%)
                  .column.shrink
                    .field Info
                    pre(style="font-family:monospace") {{item.info}}

                  .column
                    .field Payload:
                    pre {{item.payload}}
                  .column
                    .field Result:
                    .field {{JSON.stringify(item.result)}}

                  .column
                    .field Output:
                    .field(v-if="item.output")
                      a(v-on:click="openUrl(item.output)") Download

</template>
<script type="text/babel">


  import ActionButton from "../structure/ui/ActionButton.vue";
  import MdiIcon from "../structure/ui/MdiIcon.vue";
  import {EventBus} from "../../eventBus";
  import Dropdown from "../structure/foundation/Dropdown.vue";
  import KeplerBackofficeSdk from "../../lib/kepler/backoffice";

  export default {
    name: "Cargo",
    components: {
      Dropdown,
      MdiIcon,
      ActionButton
    },
    data() {
      return {}
    },
    created() {

    },
    methods: {
      openUrl: function (url) {
        window.open(url, '_blank')
      },
      stopProcessing(){
        return  KeplerBackofficeSdk.cargo.stop(this.item.id,(()=>{
          EventBus.$emit('reload-list')

        }))
      }
    },
    computed: {},
    props: {
      item: '',
      type: {
        type: String,
        default: ''
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// Cargo.vue?50870ed3